export const DEFAULT_THEME_PARAMS: HeThemeParameters = { loading: true, themeIsPresent: false };

export type HeThemeParameters = HeThemeColourParameters & HeThemeWhiteLabelParameters;

interface HeThemeColourParameters {
  primaryColour?: string;
  primaryContrastTextColour?: string;
  secondaryColour?: string;
  secondaryContrastTextColour?: string;
  tertiaryColour?: string;
  tertiaryContrastTextColour?: string;
}

export interface HeThemeWhiteLabelParameters {
  baseRoute?: string;
  bookingProfileImageUrl?: string;
  collectionPolicyUrl?: string;
  companyDisplayName?: string;
  faviconUrl?: string;
  homepage?: string;
  identityProvider?: string;
  poweredByHE?: boolean;
  privacyPolicy?: string;
  rectangularLogoUrl?: string;
  squareLogoUrl?: string;
  termsOfUse?: string;
  adobeLaunchUrl?: string;
  socialAuthEnabled?: boolean;
  governmentFlow?: boolean;
  // property to indicate that whitelabel params is still loading from endpoint.
  loading: boolean;
  // property to indicate that whitelabel params are present in the theme.
  themeIsPresent: boolean;
}
